<script setup>
import GoogleIcon from "~/components/icons/GoogleIcon.vue";
import StarIcon from "~/components/icons/StarIcon.vue";
import Text from "~/components/atoms/Text.vue";
import TrustpilotIcon from "~/components/icons/TrustpilotIcon.vue";
import TrustpilotStarIcon from "~/components/icons/TrustpilotStarIcon.vue";
import InstagramIcon from "~/components/icons/InstagramIcon.vue";
import YoutubeIcon from "~/components/icons/YoutubeIcon.vue";
import FacebookIcon from "~/components/icons/FacebookIcon.vue";
import PinterestIcon from "~/components/icons/PinterestIcon.vue";
import KlarnaIcon from "~/components/icons/KlarnaIcon.vue";
import MastercardIcon from "~/components/icons/MastercardIcon.vue";
import VisaIcon from "~/components/icons/VisaIcon.vue";
import SwishIcon from "~/components/icons/SwishIcon.vue";
import BankIdIcon from "~/components/icons/BankIdIcon.vue";
import HorizontalMenu from "~/components/molecules/HorizontalMenu.vue";
import Button from "~/components/atoms/Button.vue";
import MessageIcon from "~/components/icons/MessageIcon.vue";
import ExpandIcon from "~/components/icons/ExpandIcon.vue";
import HillceramicIcon from "~/components/icons/HillceramicIcon.vue";
import {useStartupStore} from "~/store/sturtupStore";

const startupStore = useStartupStore();

</script>

<template>
  <div class="footer full-width g-64">
    <div class="container">
      <div class="row full-width column-mobile mobile-60 footer-content">
        <div class="no-flex g-64">
          <div class="form-container">
            <nuxt-link class="full-width" :to="$t('menu.items.contact-us.link')">
              <Button type="bordered" class="full-width tall">
                <div class="full-width space-between row g-4 btn-contact-us uppercase">
                  <MessageIcon height="18px" stroke="black"/>
                  {{ $t('menu.items.contact-us.title') }}
                  <ExpandIcon stroke="black"/>
                </div>
              </Button>
            </nuxt-link>

          </div>
          <div class="row g-128 flex-start column-mobile">
            <div class="g-24 the-same-gap no-flex">
              <Text class="menu-title uppercase" tag="strong">{{ $t('footer.help') }}</Text>
              <HorizontalMenu :hide-on-mobile="false" :is-vertical="true" :items="[
                 {title:$t('menu.items.contact-us.title'),link:$t('menu.items.contact-us.link')},
                 {title:$t('menu.items.b2b.title'),link:$t('menu.items.b2b.link')},
                 {title:$t('menu.items.quotation.title'),link:$t('menu.items.quotation.link')},
                 {title:$t('menu.items.track-order.title'),link:$t('menu.items.track-order.link')},
                 {title:$t('menu.items.conditions.title'),link:$t('menu.items.conditions.link')},
                 {title:$t('menu.items.sample.title'),link:$t('menu.items.sample.link')},
                 {title:$t('menu.items.quality.title'),link:$t('menu.items.quality.link')},
            ]"/>
            </div>
            <div class="g-24 the-same-gap no-flex">
              <Text class="menu-title uppercase" tag="strong">{{ $t('footer.about') }}</Text>
              <HorizontalMenu :hide-on-mobile="false" :is-vertical="true" :items="[
                 {title:$t('menu.items.about-us.title'),link:$t('menu.items.about-us.link')},
                 {title:$t('menu.items.warehouse.title'),link:$t('menu.items.warehouse.link')},
                 {title:$t('menu.items.showroom.title'),link:$t('menu.items.showroom.link')},
                 {title:$t('menu.items.for-partners.title'),link:$t('menu.items.for-partners.link')},
                 {title:$t('menu.items.for-influencers.title'),link:$t('menu.items.for-influencers.link')},
            ]"/>
            </div>
            <div class="g-24 the-same-gap no-flex">
              <Text class="menu-title uppercase" tag="strong">{{ $t('footer.extra') }}</Text>
              <HorizontalMenu :hide-on-mobile="false" :is-vertical="true" :items="[
                 {title:$t('menu.items.blog.title'),link:$t('menu.items.blog.link')},
                 {title:$t('menu.items.collection.title'),link:$t('menu.items.collection.link')},
                 {title:$t('menu.items.tips-advice.title'),link:$t('menu.items.tips-advice.link')},
                 {title:$t('menu.items.gdpr.title'),link:$t('menu.items.gdpr.link')},
                 {title:$t('menu.items.cookiepolicy.title'),link:$t('menu.items.cookiepolicy.link')},
            ]"/>
            </div>
          </div>
        </div>
        <div class="contact-form"></div>
        <div class="about g-32">
          <div class="reviews">
            <div class="item row">
              <div class="row">
                <GoogleIcon/>
                <Text>Google Reviews</Text>
              </div>
              <div class="row">
                <Text>4.8</Text>
                <div class="row">
                  <StarIcon fill="#FCC000" v-for="_ in 5"/>
                </div>
              </div>
            </div>
            <div class="item row">
              <div class="row">
                <TrustpilotIcon/>
                <Text>Trustpilot</Text>
              </div>
              <div class="row">
                <Text>{{ startupStore.trustpilot_rating || '4.5' }}</Text>
                <div class="row trustpilot-stars">
                  <TrustpilotStarIcon v-for="_ in 5"/>
                </div>
              </div>
            </div>
          </div>
          <div class="contacts">
            <Text>{{ $t("contacts.name") }}</Text>
            <Text>{{ $t("contacts.number") }}</Text>
            <Text>{{ $t("contacts.address") }}</Text>
            <Text>{{ $t("contacts.zip") }} {{ $t("contacts.city") }}</Text>
            <Text>{{ $t("contacts.country") }}</Text>
          </div>
          <div class="social row">
            <a target="_blank" href="https://www.instagram.com/hillceramic/">
              <InstagramIcon/>
            </a>
            <a target="_blank" href="https://www.youtube.com/channel/UCrRjvxI9oLEXNDn4FK9osJQ">
              <YoutubeIcon/>
            </a>
            <a target="_blank" href="https://www.facebook.com/hillceramic/">
              <FacebookIcon/>
            </a>
            <a target="_blank" href="https://www.pinterest.se/hillceramic/">
              <PinterestIcon/>
            </a>
          </div>
          <div class="contacts">
            <Text tag="a" :href="'tel:'+$t('contacts.phone')" :underline="true">{{ $t("contacts.phone") }}</Text>
            <Text tag="a" :href="$t('menu.items.contact-us.link')" :underline="true">
              {{ $t('menu.items.contact-us.call-to-action') }}
            </Text>
          </div>

          <IconsKreditVardigIcon/>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="payment-types row">
        <KlarnaIcon/>
        <MastercardIcon/>
        <VisaIcon/>
        <SwishIcon/>
        <BankIdIcon/>
        <img src="/svg/apple-pay.svg"/>
        <img src="/svg/google-pay.svg"/>
      </div>

      <HillceramicIcon v-if="$device.isDesktop" class="center-auto logo"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.btn-contact-us {
  font-size: 14px;
}

.menu-title {
  color: $title-grey;
}

.footer-content {
  & > div {
    @include smd {
      width: 100%;
    }
  }
}

.logo {
  height: 40px;
}

.footer {
  background: $grey;
  padding: 48px 0;

  @include smd {
    flex-direction: column;
    gap: 60px;
    padding-top: 40px;
    padding-bottom: 24px;
  }

  .container {
    @include smd {
      align-items: flex-start;
      gap: 20px;
    }
  }

  .container > div {
    align-items: flex-start;

    @include smd {
      flex-wrap: wrap;
      gap: 24px;
      justify-content: flex-start;
    }
  }

  .mobile-60 {
    @include smd {
      gap: 60px;
    }
  }

  .menu {
    width: 323px;
    max-width: 323px;

    @include smd {
      width: 100%;
      max-width: 100%;
    }
  }

  .about {
    width: 275px;
    max-width: 275px;
    justify-content: flex-start;
    align-items: flex-end;

    @include smd {
      width: 100%;
      max-width: 100%;
      align-items: flex-start;
    }

    .reviews {
      gap: 22px;
      align-items: flex-end;

      @include smd {
        align-items: flex-start;
      }

      .item {
        gap: 18px;
        font-weight: 500;

        & > div {
          gap: 5px;

          & > div {
            gap: 2px;
          }
        }

        svg {
          width: 16px;
          height: 16px;
        }

        .trustpilot-stars {
          svg {
            height: 18px;
            width: 18px;
          }
        }
      }
    }

    .contacts {
      align-items: flex-end;
      gap: 5px;
      text-transform: uppercase;
      font-size: 13px;

      @include smd {
        align-items: flex-start;
        font-size: 11px;
      }
    }

    .social {
      gap: 14px;

      a {
        display: flex;
        border: 1px solid;
        border-radius: 100%;
        aspect-ratio: 1;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;

        svg {
          height: 16px;
          width: auto;
        }
      }
    }
  }

  .payment-types {
    gap: 24px;

    @include smd {
      gap: unset !important;
      justify-content: space-between !important;
      width: 100%;
    }

    svg,
    img {
      height: 18px;
      width: auto;
    }
  }

  .footer-menu {
    gap: 54px;
    justify-content: flex-end;
  }
}
</style>
